import { createSlice } from '@reduxjs/toolkit'
import { createSelector } from 'reselect';

export const currentUserSlice = createSlice({
    name: 'currentUser',
    initialState: {
        userData: [],
    },
    reducers: {
        setUserData: (state, action) => {
            state.userData = action.payload;
        },
    },
})

export const { setUserData } = currentUserSlice.actions

export default currentUserSlice.reducer